module.exports = __webpack_public_path__ + "img/fxyzt.bc1e752a.jpg";